import { STATE_REGION_URL } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'
import Cookies from 'universal-cookie';

const cook = new Cookies().get('loginData1')


const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': cook != undefined ? cook.accessToken : ''
        // 'Authorization': url.Auth_Token
}


export const addStateRegion = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(STATE_REGION_URL(), data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getStateKeyValue = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(STATE_REGION_URL() + "getKeyValueListForAddress", { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getStateRegionKeyValuePair = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(STATE_REGION_URL() + "getKeyValueList", { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getStateRegionDetailsbyUUID = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(STATE_REGION_URL() + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};